import format from 'date-fns/format'

import type { TBookingContext } from '@providers/booking/types'
import { ClientInvoiceService } from 'service-api/src/services/client_invoice.service'
import type { CustomInvoiceClientDto } from 'service-api/src/types/api'
import { Status } from 'service-api/src/types/general'

export const buildDaycareVisitPeriod = (state: TBookingContext): string[] => {
  return (
    state.cart?.groups
      ?.map((group) => group.daycareSelected?.map((daycare) => daycare.date))
      .flat()
      .filter(Boolean)
      .map((date) => format(date!, 'yyyy-MM-dd')) ?? []
  )
}

export const buildGroomingVisitPeriod = (state: TBookingContext): string[] => {
  return (
    state.cart?.groups?.flatMap((group) =>
      group.grooms.flatMap((groom) => groom.requestDates.map(({ date }) => format(date, 'yyyy-MM-dd')))
    ) ?? []
  )
}

export const buildOvernightVisitPeriod = (startDate: Date, endDate: Date): string[] => {
  return [`${format(startDate, 'yyyy-MM-dd')}_${format(endDate, 'yyyy-MM-dd')}`]
}

export const fetchVisitConflictingInvoices = async (
  locationName: string,
  period: string[],
  locationPetProfileIds: string[]
): Promise<CustomInvoiceClientDto[]> => {
  if (!period.length || !locationPetProfileIds.length) return []

  const response = await ClientInvoiceService.getList(locationName, {
    invoiceStatus: [Status.CONFIRMED],
    isInStay: false,
    period,
    'locationServiceType.serviceType.isVisit': true,
    'petRelations.invoicePet.locationPetProfileId': locationPetProfileIds,
    includes: ['petRelations.invoicePet.locationPetProfile', 'period', 'locationServiceType.serviceType'],
  })

  return response.results ?? []
}
